<script lang="ts">
  import ProgressBarTime from '../components/ProgressBarTime.svelte'
  import { getProgressBarContext } from '../progressBarContext'

  type Props = {
    duration: number
  }

  let { duration }: Props = $props()

  let width = $state(0)

  const progressBarContext = getProgressBarContext()

  let leftPos = $derived.by(() => {
    const pos =
      (progressBarContext.isLiveStream
        ? duration - progressBarContext.hoverTime
        : progressBarContext.hoverTime) / duration

    const minPos = width / 2 / progressBarContext.width

    if (pos < minPos) {
      return minPos * 100
    }

    const maxPos =
      (progressBarContext.width - width / 2) / progressBarContext.width
    return (pos > maxPos ? maxPos : pos) * 100
  })
</script>

{#if progressBarContext.hoverTime}
  <ProgressBarTime
    seconds={progressBarContext.hoverTime}
    class="transform -translate-x-1/2"
    style={`left: ${leftPos}%;`}
    isNegative={progressBarContext.isLiveStream}
    bind:width
  />
{/if}
